export interface TypographyInterface {
  font: {
    primary: string
    size: {
      big: string
      medium: string
      small: string
      x: {
        big: string
        medium: string
        small: string
      }
      xx: {
        big: string
        medium: string
        small: string
      }
      xxx: {
        big: string
        medium: string
        small: string
      }
    }
    weight: {
      medium: string
      bold: string
    }
    align: {
      left: string
      center: string
      right: string
    }
  }
  text: {
    decoration: {
      uppercase: string
      underline: string
      linethrough: string
    }
  }
  lineHeight: string
}

export const typography: TypographyInterface = {
  font: {
    primary: 'Manrope',
    size: {
      big: '30px',
      medium: '26px',
      small: '16px',
      x: {
        big: '36px',
        medium: '22px',
        small: '14px'
      },
      xx: {
        big: '40px',
        medium: '20px',
        small: '12px'
      },
      xxx: {
        big: '60px',
        medium: '18px',
        small: '10px'
      }
    },
    weight: {
      medium: 'Manrope Medium',
      bold: 'Manrope Bold'
    },
    align: {
      left: 'left',
      center: 'center',
      right: 'right'
    }
  },
  text: {
    decoration: {
      uppercase: 'uppercase',
      underline: 'underline',
      linethrough: 'line-through'
    }
  },
  lineHeight: 'normal'
}
